(() => {
  const returnTitle = document.currentScript?.dataset.returnTitle;
  if (!returnTitle || window.Shopify?.designMode) return;

  let pageTitle = document.title;

  const syncTitle = () => {
    if (document.visibilityState === 'hidden') {
      if (document.title !== returnTitle) pageTitle = document.title;
      document.title = returnTitle;
    } else if (document.title === returnTitle) {
      document.title = pageTitle;
    }
  };

  document.addEventListener('visibilitychange', syncTitle);
  window.addEventListener('pageshow', syncTitle);
  syncTitle();
})();
